// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GET_COUNT_TOTAL_NOTIFICATION, GET_COUNT_TOTAL_NOTIFICATION_DONE, GET_DETAIL_NOTIFICATION, GET_LIST_NOTIFICATION, GET_LIST_NOTIFICATION_DONE, UPDATE_STATUS_NOTIFICATION } from "./constant";

export const ActionGetListNoti = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_LIST_NOTIFICATION,
    payload,
    callback
  };
};

export const ActionGetListNotiDone = (data: any) => ({
  type: GET_LIST_NOTIFICATION_DONE,
  payload: data
})

export const ActionGetCountTotalNoti = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_COUNT_TOTAL_NOTIFICATION,
    payload,
    callback
  };
};

export const ActionGetCountTotalNotiDone = (data: any) => ({
  type: GET_COUNT_TOTAL_NOTIFICATION_DONE,
  payload: data
})

export const ActionUpdateStatusNoti = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: UPDATE_STATUS_NOTIFICATION,
    payload: payload,
    callback
  };
};

export const ActionGetDetailNoti = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_DETAIL_NOTIFICATION,
    payload,
    callback
  };
};